export default () => ({
  dependents: [],
})
